export interface SubtitlesProps {
    subtitles?: string[];
    subtitlesRatio?: SubtitlesRatio;
    subtitlesDirection: SubtitlesDirection;
    isSelectEnabled?: boolean;
    /** In pixels */
    offset?: {
        x: number;
        y: number;
    };
}

export const subtitlesRatioValues = {
    SMALL: 0.75,
    NORMAL: 1,
    LARGE: 1.25,
} as const;

export const subtitlesPosition = {
    TOP: 'top',
    BOTTOM: 'bottom',
} as const;

export const subtitlesDirection = {
    RTL: 'rtl',
    LTR: 'ltr',
} as const;

export const sideShortSizeMode = {
    SMALL: 'small',
    NORMAL: 'normal',
} as const;

export interface ScreenInfo {
    shortSideSize: number;
    screenCoef: number;
    sizeMode: SideShortSizeMode;
}

export type SubtitlesRatio = (typeof subtitlesRatioValues)[keyof typeof subtitlesRatioValues];
export type SubtitlesPosition = (typeof subtitlesPosition)[keyof typeof subtitlesPosition];
export type SubtitlesDirection = (typeof subtitlesDirection)[keyof typeof subtitlesDirection];
export type SideShortSizeMode = (typeof sideShortSizeMode)[keyof typeof sideShortSizeMode];
